var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-option-choice"},[(_vm.options && _vm.options.length)?_vm._l((_vm.options),function(option){return _c('span',{key:option,staticClass:"cm-option-choice__text"},[_vm._v(" "+_vm._s(option)+" ")])}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }